"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.timers");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formElements = require("@evidation/form-elements");

var _mobile = _interopRequireDefault(require("../GAD7/mobile"));

var _components = require("./components");

var _lodash = _interopRequireDefault(require("lodash"));

var _validations = _interopRequireDefault(require("./validations"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var calculateSum = function calculateSum(values) {
  return _lodash["default"].reduce(values, function (acc, v, k) {
    return acc + v;
  }, 0);
};

var Page = function Page(_ref) {
  var onBack = _ref.onBack,
      onNext = _ref.onNext,
      children = _ref.children,
      hideNext = _ref.hideNext,
      _ref$showCopyright = _ref.showCopyright,
      showCopyright = _ref$showCopyright === void 0 ? true : _ref$showCopyright;
  return /*#__PURE__*/_react["default"].createElement(_components.PageContainer, null, children, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexFlow: 'column',
      marginTop: 'auto'
    }
  }, showCopyright && /*#__PURE__*/_react["default"].createElement(_components.CopyRight, null), /*#__PURE__*/_react["default"].createElement(_components.NaVButtons, {
    onBack: onBack,
    hideNext: hideNext
  }, onBack && /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    id: "t-next_button",
    buttonStyle: "achievement",
    onClick: onBack
  }, "back"), !hideNext && /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    id: "t-next_button",
    buttonStyle: "achievement",
    onClick: onNext
  }, "next"))));
};

var PostSurveyPages = [_components.ThankYou, _components.ReviewPage, _components.ForMoreInformation];

var ESS = function ESS(_ref2) {
  var _ref2$input = _ref2.input,
      onChange = _ref2$input.onChange,
      name = _ref2$input.name,
      restInput = (0, _objectWithoutProperties2["default"])(_ref2$input, ["onChange", "name"]),
      questions = _ref2.questions,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["input", "questions"]);

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var _useState3 = (0, _react.useState)(-1),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      questionIndex = _useState4[0],
      setQuestionIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      completedSurvey = _useState6[0],
      setCompletedSurvey = _useState6[1];

  var _onNext = function onNext() {
    return setQuestionIndex(questionIndex + 1);
  };

  var _onBack = function onBack() {
    return setQuestionIndex(questionIndex - 1);
  };

  var allQuestionsAnswered = function allQuestionsAnswered(values) {
    return Object.keys(values).length === questions.length + 1;
  };

  if (questionIndex === -1) return /*#__PURE__*/_react["default"].createElement(Page, {
    onNext: _onNext
  }, /*#__PURE__*/_react["default"].createElement(_components.Title, null));else if (questionIndex < questions.length) return /*#__PURE__*/_react["default"].createElement(_mobile["default"], (0, _extends2["default"])({}, props, restInput, {
    name: name,
    value: values["".concat(name, "_").concat(questionIndex + 1)],
    key: questionIndex,
    question: "Situation: ".concat(questions[questionIndex]),
    progress: (questionIndex + 1) / questions.length * 100,
    onChange: function onChange(d) {
      var newValues = _objectSpread(_objectSpread({}, _lodash["default"].omit(values, name)), {}, (0, _defineProperty2["default"])({}, "".concat(name, "_").concat(questionIndex + 1), d));

      var valuesWithSum = _objectSpread(_objectSpread({}, newValues), {}, (0, _defineProperty2["default"])({}, name, calculateSum(newValues)));

      setValues(valuesWithSum); // if we already have a complete survey jump to review page

      if (completedSurvey) setTimeout(function () {
        return setQuestionIndex(questions.length + 1);
      }, 200);else if (allQuestionsAnswered(valuesWithSum)) {
        setCompletedSurvey(true);
        setTimeout(_onNext, 200);
      } else setTimeout(_onNext, 200);
    },
    onBack: _onBack,
    disableBack: _lodash["default"].isEqual(questionIndex, -1),
    Footer: _components.CopyRight
  }));else {
    var isSecondToLastPage = questionIndex === questions.length + PostSurveyPages.length - 2;
    var isLastPage = questionIndex === questions.length + PostSurveyPages.length - 1;
    return /*#__PURE__*/_react["default"].createElement(Page, {
      onNext: function onNext() {
        // doing this to keep submit disabled until last page
        if (isSecondToLastPage) onChange(values);

        _onNext();
      },
      onBack: function onBack() {
        // and to disable it when navigating back
        if (isLastPage) onChange({});

        _onBack();
      },
      hideNext: isLastPage,
      showCopyright: !isLastPage
    }, PostSurveyPages[questionIndex - questions.length](_objectSpread(_objectSpread({}, props), {}, {
      questions: questions,
      setQuestionIndex: setQuestionIndex,
      values: values
    })));
  }
};

ESS.defaultProps = {
  question_label: /*#__PURE__*/_react["default"].createElement("p", null, "How likely are you to doze off or fall asleep in the following situation, in contrast to feeling just tired?"),
  questions: ['Sitting and reading', 'Watching TV', 'Sitting, inactive in a public place (e.g. a theater or a meeting)', 'As a passenger in a car for an hour without a break', 'Lying down to rest in the afternoon when circumstances permit', 'Sitting and talking to someone', 'Sitting quietly after a lunch without alcohol', 'In a car, while stopped for a few minutes in the traffic'],
  answer_labels: ['<b>0 =</b> would <b>never</b> doze', '<b>1 = slight chance</b> of dozing', '<b>2 = moderate chance</b> of dozing', '<b>3 = high chance</b> of dozing'],
  input: {}
};
ESS.propTypes = {
  input: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onBlur: _propTypes["default"].func,
    onFocus: _propTypes["default"].func
  })
};
var _default = ESS;
exports["default"] = _default;